/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsHomepageBanner = {
    init: function ($section) {
      gsap.registerPlugin(ScrollTrigger);
      this.$section = $section;
      Shopify.theme.jsHomepageBanner = $.extend(this, Shopify.theme.getSectionData($section));      
      var _this = this;
      // var main_header = $('.header-section').detach();
      // $section.prepend(main_header);

      const main_header = $('.header-section');
      const newParent = $('.homepage_header_wrapper');
      main_header.children().appendTo(newParent);

      const element_wrap = $section.find('.banner_img_wrap');
      const default_element_wrap = $section.find('.banner_img_wrap .main_image');
      const tl = gsap.timeline({ repeat: -1 });
      const frameRate = 30; // Frames per second
      const frameCount = 110; // Total number of frames in the sequence

      const currentFrame = index => (
        `https://cdn.shopify.com/s/files/1/0763/1296/9503/files/Comp_${(index + 1).toString().padStart(5, '0')}.png`
      );

      let images = [];
      let loadedCount = 0;
      for (let i = 0; i < frameCount-1; i++) {
        let img = new Image();
        img.src = currentFrame(i);
        var img_src = currentFrame(i);
        img.classList.add('animated_img');
        images.push(img);

        img.onload = function () {
          loadedCount++;
          if (loadedCount === images.length) {
          $(".animated_img").show();
          default_element_wrap.hide();
          }
        };
      }    
      // Add the images to the image container
      images.forEach((image, index) => {
        element_wrap.append(image);
        if (index !== 0) {
          gsap.set(image, { visibility: 'hidden' });
        }
      }); 
      // Animate the visibility change of images on the timeline
      images.forEach((image, index) => {
        const duration = 1 / frameRate;

        tl.set(image, { visibility: 'visible', duration }, index * duration);
        tl.set(image, { visibility: 'hidden', duration }, (index + 1) * duration + 0.001 );
      });

      tl.timeScale(frameRate);
      
      const animationDuration = frameCount / frameRate;// Adjust the duration of the animation based on the frame rate and frame count
      tl.totalDuration(animationDuration); // Adjust the total duration of the timeline to match the animation duration
      gsap.set(element_wrap, { clearProps: 'all' });// Attach the timeline to the image container to control the playback
      tl.play(0);

      // Get the SVG element and the text element
      const svgElement = document.querySelector('.custom_svg');
      const textElement = document.querySelector('.svg-text-outline');
      const pathElement = svgElement.querySelector('#wave');

      var header = document.querySelector('.header-section');
      var newheader = document.querySelector('.homepage_header_wrapper');
      var animated_img = document.querySelector('.banner_img_wrap');
      
      this.scrollAnimation(header, textElement, newheader,animated_img);
      
      this.updateSVG(svgElement, textElement, pathElement);
      window.addEventListener('resize', function(){
        Shopify.theme.jsHomepageBanner.updateSVG(svgElement, textElement, pathElement);
      });
      // function update($section){
      //   Shopify.theme.jsHomepageBanner.updateSVG(svgElement, textElement, pathElement);
      // }
      setTimeout(function(){
        Shopify.theme.jsHomepageBanner.updateSVG(svgElement, textElement, pathElement);
        svgElement.style.visibility = 'visible';
      },200);

    },
    updateSVG: function(svgElement, textElement, pathElement){
      const textHeight = 0.8 * (textElement.getBBox().height);
      const screenWidth = window.innerWidth;
      const viewBoxWidth = textElement.getBBox().width;
      const aspectRatio = viewBoxWidth / textHeight;
      const viewBox = `0 -1 ${viewBoxWidth} ${textHeight}`;
      const newPathValue = `M.005 121C311 121 409.898-.25 811 0c400 0 500 121 789 121v${textHeight}H0s.005-48 .005-${textHeight}z`;

      const svg_height = textHeight + 10;
        pathElement.setAttribute('d', newPathValue);
        svgElement.setAttribute('height', svg_height);
        svgElement.setAttribute('viewBox', viewBox);
        // svgElement.style.visibility = 'visible';
        $(".noanimation.text-outline").hide();
        this.$section.find(".banner_img_wrap img").css("max-height",textHeight*0.8);
           
    },
    scrollAnimation: function(header, textElement, newheader,animated_img){
      ScrollTrigger.saveStyles(".homepage_banner_section, .header-section",'#wave-bg-path', ".custom_svg .wave_bg > use");


      const textHeight = 0.8 * (textElement.getBBox().height);
      // ScrollTrigger.normalizeScroll(true);
      var headerHeight = header.offsetHeight;
      if(headerHeight == 0){
        headerHeight = newheader.offsetHeight;
      }
      let mobile_start = headerHeight + animated_img.offsetHeight;
      ScrollTrigger.matchMedia({
         // desktop
        "(min-width: 798px)": () => {
          bannerTimelineInstance = gsap.timeline();
          headerTimelineInstance = gsap.timeline();
          
          bannerTimelineInstance
            .set("#wave-bg-path", { attr:{y:textHeight}})
            .addLabel("start")
            .to("#wave-bg-path", {attr:{y:"0"}, ease:"power1.out", duration:6 })
            .addLabel("stop");  
          bannerTimelineInstance.add(
            ScrollTrigger.create({
              animation: bannerTimelineInstance,
              start:"top " + headerHeight + "px",
              end:"+="+textHeight,
              pin:".homapage_banner",
              pinType: "fixed",
              trigger:".homepage_banner_section",
              scrub: 1,
              pinSpacing: true,
              // markers:true,
            })
          );
        },
        "(max-width: 799px)": () =>{
          // $(".noanimation.text-outline").show();
            // ScrollTrigger.getAll().forEach((trigger) => trigger.kill()); // Remove all ScrollTriggers
        bannerTimelineInstance = gsap.timeline();
          headerTimelineInstance = gsap.timeline();
                    
          bannerTimelineInstance
            .set("#wave-bg-path", { attr:{y:textHeight}})
            .addLabel("start")
            .to("#wave-bg-path", {attr:{y:"0"}, ease:"power1.out", duration:6 })
            .addLabel("stop");  
          bannerTimelineInstance.add(
            ScrollTrigger.create({
              animation: bannerTimelineInstance,
              start:"top " + headerHeight + "px",
              end:"+="+textHeight,
              pin:".homapage_banner",
              pinType: "fixed",
              trigger:".homepage_banner_section",
              scrub: 1,
              pinSpacing: true,
              // markers:true,
            })
          );
        }
      });
   
    },
    unload: function ($section) {
    }
  }
  /******/
})();